import PHL_S from "./rounded_flags_shadows/philippines.png"
import MYS_S from "./rounded_flags_shadows/malaysia.png";
import TWN_S from "./rounded_flags_shadows/taiwan.png";
import IDN_S from "./rounded_flags_shadows/indonesia.png";
import SGP_S from "./rounded_flags_shadows/singapore.png";
import AUS_S from "./rounded_flags_shadows/australia.png";
import HKG_S from "./rounded_flags_shadows/hong-kong.png";
import VNM_S from "./rounded_flags_shadows/vietnam.png";
import EUR_S from "./rounded_flags_shadows/european-union.png";
import GBR_S from "./rounded_flags_shadows/united-kingdom.png";
import CAN_S from "./rounded_flags_shadows/canada.png";
import JPN_S from "./rounded_flags_shadows/japan.png";
import CHN_S from "./rounded_flags_shadows/china.png";
import IND_S from "./rounded_flags_shadows/india.png";
import DNK_S from "./rounded_flags_shadows/denmark.png";
import CHE_S from "./rounded_flags_shadows/switzerland.png";
import KOR_S from "./rounded_flags_shadows/south-korea.png";
import THA_S from "./rounded_flags_shadows/thailand.png";
import NZD_S from "./rounded_flags_shadows/new-zealand.png";
import NOK_S from "./rounded_flags_shadows/norway.png";
import SEK_S from "./rounded_flags_shadows/sweden.png";
import USD_S from "./rounded_flags_shadows/united-states.png";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    PHL_S,
    MYS_S,
    TWN_S,
    IDN_S,
    SGP_S,
    AUS_S,
    HKG_S,
    VNM_S,
    EUR_S,
    GBR_S,
    CAN_S,
    JPN_S,
    CHN_S,
    IND_S,
    DNK_S,
    CHE_S,
    KOR_S,
    THA_S,
    NZD_S,
    NOK_S,
    SEK_S,
    USD_S,
} as any;